var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2605_4370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.26666 7.96667C3.97211 7.96667 3.73333 8.20545 3.73333 8.5V9.56667C3.73333 9.86122 3.97211 10.1 4.26666 10.1H5.33332C5.62788 10.1 5.86666 9.86122 5.86666 9.56667V8.5C5.86666 8.20545 5.62788 7.96667 5.33332 7.96667H4.26666Z",
    fill: "#818183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26666 11.1667C3.97211 11.1667 3.73333 11.4054 3.73333 11.7V12.7667C3.73333 13.0612 3.97211 13.3 4.26666 13.3H5.33332C5.62788 13.3 5.86666 13.0612 5.86666 12.7667V11.7C5.86666 11.4054 5.62788 11.1667 5.33332 11.1667H4.26666Z",
    fill: "#818183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93332 11.7C6.93332 11.4054 7.17211 11.1667 7.46666 11.1667H8.53332C8.82788 11.1667 9.06666 11.4054 9.06666 11.7V12.7667C9.06666 13.0612 8.82788 13.3 8.53332 13.3H7.46666C7.17211 13.3 6.93332 13.0612 6.93332 12.7667V11.7Z",
    fill: "#818183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46666 7.96667C7.17211 7.96667 6.93332 8.20545 6.93332 8.5V9.56667C6.93332 9.86122 7.17211 10.1 7.46666 10.1H8.53332C8.82788 10.1 9.06666 9.86122 9.06666 9.56667V8.5C9.06666 8.20545 8.82788 7.96667 8.53332 7.96667H7.46666Z",
    fill: "#818183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1333 11.7C10.1333 11.4054 10.3721 11.1667 10.6667 11.1667H11.7333C12.0279 11.1667 12.2667 11.4054 12.2667 11.7V12.7667C12.2667 13.0612 12.0279 13.3 11.7333 13.3H10.6667C10.3721 13.3 10.1333 13.0612 10.1333 12.7667V11.7Z",
    fill: "#818183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 7.96667C10.3721 7.96667 10.1333 8.20545 10.1333 8.5V9.56667C10.1333 9.86122 10.3721 10.1 10.6667 10.1H11.7333C12.0279 10.1 12.2667 9.86122 12.2667 9.56667V8.5C12.2667 8.20545 12.0279 7.96667 11.7333 7.96667H10.6667Z",
    fill: "#818183"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73333 0.5C4.02788 0.5 4.26666 0.738781 4.26666 1.03333V1.56667H7.46666V1.03333C7.46666 0.738781 7.70544 0.5 7.99999 0.5C8.29454 0.5 8.53332 0.738781 8.53332 1.03333V1.56667H11.7333V1.03333C11.7333 0.738781 11.9721 0.5 12.2667 0.5C12.5612 0.5 12.8 0.738781 12.8 1.03333V1.56667H14.4C14.9891 1.56667 15.4667 2.04423 15.4667 2.63333V15.4333C15.4667 16.0224 14.9891 16.5 14.4 16.5H1.59999C1.01089 16.5 0.533325 16.0224 0.533325 15.4333V2.63333C0.533325 2.04423 1.01089 1.56667 1.59999 1.56667H3.19999V1.03333C3.19999 0.738781 3.43877 0.5 3.73333 0.5ZM8.53332 2.63333H11.7333V3.16667C11.7333 3.46122 11.9721 3.7 12.2667 3.7C12.5612 3.7 12.8 3.46122 12.8 3.16667V2.63333H14.4V4.76667H1.59999V2.63333H3.19999V3.16667C3.19999 3.46122 3.43877 3.7 3.73333 3.7C4.02788 3.7 4.26666 3.46122 4.26666 3.16667V2.63333H7.46666V3.16667C7.46666 3.46122 7.70544 3.7 7.99999 3.7C8.29454 3.7 8.53332 3.46122 8.53332 3.16667V2.63333ZM14.4 15.4333V5.83333H1.59999V15.4333H14.4Z",
    fill: "#818183"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2605_4370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d2ca69ae86d7b89ac77b2892bd37c0bb.svg";
export { ForwardRef as ReactComponent };